type JSXString = string | JSX.Element;

type Props = {
  children: JSXString[] | JSXString;
};

export const AuthCardTitle = ({ children }: Props) => (
  <h1 className="text-4xl font-auth-title text-primary font-bold text-center my-4">{children}</h1>
);
